import { format, formatDistanceToNow, differenceInDays } from 'date-fns';

// ----------------------------------------------------------------------

export function fDate(date) {
  return format(new Date(date), 'dd MMMM yyyy');
}

export function fDatePadrao(date) {
  return format(new Date(date), 'dd/MM/yyyy');
}

export function fDateFormatCalendario(date) {
  return format(new Date(date), 'yyyy-MM-dd');
}

export function fDateTime(date) {
  return format(new Date(date), 'dd/MM/yyyy HH:mm');
}

export function fDateTimeSuffix(date) {
  return format(new Date(date), 'dd/MM/yyyy hh:mm p');
}

export function fToNow(date) {
  return formatDistanceToNow(new Date(date), {
    addSuffix: true,
  });
}

export function fDiferencaEntreDatas(date1, date2){
  return differenceInDays(date1, date2) + 1;
}
